import { createAction, props } from "@ngrx/store";
import { BankCountryConfig } from 'app/profile/models/bank.model';

export const GetBankCountries = createAction(
    '[BANK] Get Bank Countries',
    props<{ supplierCode: string }>()
);

export const GetBankCountriesSuccess = createAction(
    '[BANK] Get Tax Counties Success',
    props<{ supplierCode: string, countries: BankCountryConfig[] }>()
);
